import styles from './Card.module.css';

export default function Card({ children, className = '', hover = true, ...rest }) {
  return (
    <div className={`${styles.card} ${hover ? styles.hover : ''} ${className}`} {...rest}>
      {children}
    </div>
  );
}
